import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class TrackingGiftSummary extends BaseModel {
    @Expose() giftKm = 0.0;
    @Expose() periodGiftDiscount = 0.0;
    @Expose() periodGiftKm = 0.0;
    @Expose() totalGiftDiscount = 0.0;
    @Expose() totalGiftKm = 0.0;
}
